export default __webpack_public_path__ + "static/media/fileFolderPerms.37745669.png";